import { z } from 'zod';

// 1. Esquema de validación con Zod (Runtime validation)
export const UniversitySchema = z.object({
  name: z.string().min(3, 'El nombre debe tener al menos 3 caracteres').max(160, 'El nombre no puede exceder los 160 caracteres'),
  acronym: z.string().min(2, 'El acrónimo es obligatorio').max(20,'El acrónimo no puede exceder los 20 caracteres'),
  city: z.string().min(3, 'La ciudad es obligatoria').max(100,'La ciudad no puede exceder los 100 caracteres'),
});

// 2. Data necesaria para Crear (Payload) 
// Inferimos el tipo directamente del esquema de Zod
export type IUniversityCreateRequest = z.infer<typeof UniversitySchema>;

// 3. Interfaz base de la Universidad
export interface IUniversity extends IUniversityCreateRequest {
  id: string;
  created_at: string;
}

// 4. Tipo de la Respuesta
export type IUniversitiesResponse = IUniversity[];

// 5. Tipo de los Filtros/Params (Query Params)
export interface IUniversitiesParams {
  page?: number;
  perPage?: number;
  name?: string;
  city?: string;
}

// 6. Data necesaria para Actualizar (Payload)
export interface IUniversityUpdateRequest extends Partial<IUniversityCreateRequest> {}

// 7. Respuesta de eliminación
export interface IUniversityDeleteResponse {
  message: string;
}